import { call, put } from "redux-saga/effects";
import { branchService } from "../services/branchService";
import { branchConstants } from "../actions/constants/branchConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* enableBranches(action: any): any {
  try {
    const response = yield call(branchService.enableBranches, action.payload);
    if (response.success) {
      yield put({ type: branchConstants.enableBranchesSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: branchConstants.enableBranchesFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: branchConstants.enableBranchesFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* createBranch(action: any): any {
  try {
    const response = yield call(branchService.createBranch, action.payload);
    if (response.success) {
      yield put({ type: branchConstants.createBranchSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: branchConstants.createBranchFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: branchConstants.createBranchFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* listBranches(action: any): any {
  try {
    const response = yield call(branchService.listBranches, action.payload);
    if (response.success) {
      yield put({ type: branchConstants.listBranchesSuccess, payload: response.resultObject });
    } else {
      yield put({ type: branchConstants.listBranchesFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: branchConstants.listBranchesFailure, payload: error });
  }
}

function* switchTenant(action: any): any {
  try {
    const response = yield call(branchService.switchTenant, action.payload);
    if (response.success) {
      yield put({ type: branchConstants.switchTenantSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: branchConstants.switchTenantFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: branchConstants.switchTenantFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const branchSaga = {
  enableBranches,
  createBranch,
  listBranches,
  switchTenant,
};
